// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { VueBus } from './lib/common';
import ElementUI from 'element-ui';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// import 'element-ui/lib/theme-default/index.css';    // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
// import './element-variables.scss';       // 浅绿色主题
// import 'element-ui/lib/theme-chalk/index.css';
import './lib/elementui.css';

// import "babel-polyfill";
import es6Promise from 'es6-promise';
if (!window.Promise) {
  es6Promise.polyfill();
}


// 对Date的扩展，将 Date 转化为指定格式的String  
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
// 例子：   
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423   
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18   
Date.prototype.format = function(fmt){  
	var o = {  
		 "M+": this.getMonth()+1,  
		 "d+": this.getDate(),  
		 "H+": this.getHours(),  
		 "m+": this.getMinutes(),  
		 "s+": this.getSeconds(),  
		 "S+": this.getMilliseconds()  
	};  
  
	//因位date.getFullYear()出来的结果是number类型的,所以为了让结果变成字符串型，下面有两种方法：  
  
	  
  
	if(/(y+)/.test(fmt)){  
		//第一种：利用字符串连接符“+”给date.getFullYear()+""，加一个空字符串便可以将number类型转换成字符串。  
  
		fmt=fmt.replace(RegExp.$1,(this.getFullYear()+"").substr(4-RegExp.$1.length));  
	}  
	for(var k in o){  
		if (new RegExp("(" + k +")").test(fmt)){  
  
			//第二种：使用String()类型进行强制数据类型转换String(date.getFullYear())，这种更容易理解。  
  
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(String(o[k]).length)));  
		}  
	}     
	return fmt;  
  }  

  
const resizeCallbacks = []
function setViewport() {
	var doc = window.document;
	let metaDom = doc.getElementsByTagName('meta')[1];
	metaDom.content = `width=device-width,initial-scale=1,minimum-scale=0.1,maximum-scale=1 minimal-ui`;
	var windowWidth = doc.documentElement.clientWidth || doc.body.clientWidth || window.innerWidth;
	console.log('windowWidth',windowWidth)
	if (windowWidth < 1100) {
		let scale = windowWidth/1100;
		metaDom.content = `width=device-width,initial-scale=${scale},minimum-scale=0.1,maximum-scale=1 minimal-ui`;
	}
	console.log('windowWidth',doc.documentElement.clientWidth || doc.body.clientWidth || window.innerWidth);
	resizeCallbacks.map(f => {
		try {
			f();
		} catch (e) {}
	})
}
window.onload = setViewport;
setViewport();
window.onresize = setViewport;
window.watchResize = (f) => {
	resizeCallbacks.push(f);
}

Vue.config.productionTip = false
Vue.use(VueBus);
Vue.use(ElementUI);
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999,
		navbar: 0,
		title: 0,
		toolbar: {
			zoomIn: 1,
			zoomOut: 1,
			oneToOne: 1,
			reset: 1,
			rotateLeft: 1,
			rotateRight: 1,
			flipHorizontal: 1,
			flipVertical: 1,
			prev: 0, play: {show: 0, size: 'large',},next: 0
		}
	}
});
/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js